import {
  testAWSConnection,
  testAzureConnection,
  testGcpConnection,
  testSnowflakeConnection,
  setNewAWSCredentials,
  setNewGCPCredentials,
} from "../../../store/slices/accounts/accountThunks";

// Cada provider tiene su propio thunk de test, y cada uno compara el status
// de la respuesta a su manera (`'true'` como string, o `200` numérico).
// El mapa los mantiene separados a propósito: unificar esas comparaciones
// cambiaría el comportamiento de tres providers de un plumazo.
const TEST_THUNKS = {
  AWS: testAWSConnection,
  Azure: testAzureConnection,
  GCP: testGcpConnection,
  Snowflake: testSnowflakeConnection,
};

// Solo el test de Azure manda el email del usuario: los otros tres
// providers no lo incluyen en el body del test.
const TEST_NEEDS_USER = { Azure: true };

export const dispatchTestConnection = (dispatch, provider, body, user) =>
  dispatch(TEST_THUNKS[provider](TEST_NEEDS_USER[provider] ? { ...body, user } : body));

// AWS, Azure y Snowflake guardan con un body serializado; GCP con el objeto.
// `accountName` e `idAccount` se agregan acá porque son comunes a la alta y
// a la edición, y el flag `update` es lo único que las distingue.
export const dispatchSaveCredentials = (dispatch, provider, { data, idTenant, user, accountId }) => {
  const body = {
    data,
    idtenant: idTenant,
    user,
  };
  if (accountId) {
    body.update = 1;
    body.idAccount = accountId;
  }

  if (provider === "GCP") {
    return dispatch(setNewGCPCredentials(body));
  }
  return dispatch(setNewAWSCredentials(JSON.stringify(body)));
};
